import { render, staticRenderFns } from "./DatasourceDialog.vue?vue&type=template&id=0ae3a1ab"
import script from "./DatasourceDialog.vue?vue&type=script&lang=js"
export * from "./DatasourceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports